import React, { useState } from "react";
import { GenericDiv, Label, PopupForm, TextArea } from "../common/Style";
import { sendMsg } from "../../store/reducers/efratReducer";
import { toast } from "react-toastify";
import { parseIsoDate } from "../common/others/Functions";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

const Msg = ({ user, init, selfInit }) => {
  const dispatch = useDispatch();
  const [tempMsg, setTempMsg] = useState(
    `כבר עברה שנה? יום נישואין שמח אהובים שלנו, מתגעגעים ❤️ \n
מתחם האירועים סופיה`
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [date, setDate] = useState(new Date(user.date));

  const handleSendMsg = async () => {
    let tempDate = date;
    // tempDate.setFullYear(date.getFullYear() - 1);
    tempDate = parseIsoDate(tempDate);
    tempDate = tempDate.split("/");
    let tts = `${parseInt(tempDate[2]) + 1}-${tempDate[1]}-${
      tempDate[0]
    } 11:00:00`;
    const body = {
      Recipients: [{ msg: tempMsg, Phone: user.bridePhone }],
      TimeToSend: tts,
    };
    dispatch(sendMsg(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        selfInit();
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
      style={{ position: "relative" }}
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
          marginTop: "40px",
        }}
      >
        <Label>תוכן ההודעה</Label>
        <TextArea
          defaultValue={tempMsg}
          onChange={(e) => setTempMsg(e.target.value)}
          type="text"
          rows="5"
        />
        <GenericDiv
          onClick={handleSendMsg}
          style={{ width: "100%", marginTop: "30px" }}
        >
          שליחה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default Msg;
